// extracted by mini-css-extract-plugin
export default {"message":"FormText_message__zEfQT"};